import WarningRow from './WarningRow';

export default WarningRow;



// WEBPACK FOOTER //
// ./src/components/WarningRow/index.js